import { Injectable } from '@angular/core';
import { PointsService } from './points.service';
import { ToolsControlService } from './tools-control.service';
import { TrajectoryService } from './trajectory.service';

@Injectable({
  providedIn: 'root'
})
export class TrajectoryFilterService {

  active : boolean = false;
  fullScreenMode : boolean = false;
  loading : boolean = false;

  constructor(private toolsService : ToolsControlService,
     private trajectoryService: TrajectoryService,
     private pointsService : PointsService) { }


  openWindow():void {
    this.active = true;
    this.toolsService.navigationOnTop = true;
    this.getTrajectoriesFromDataBase();
  }

  getTrajectoriesFromDataBase() : void {
    this.loading = true;
    this.pointsService.getTrajectories().subscribe((results) => {
      this.trajectoryService.trajectories = results;
      this.loading = false;
    });
  }
}
